module.exports = __webpack_public_path__ + "img/karriere-v1.b4832329.jpg";